import { useRouter } from 'next/router';
import { useCookies } from './cookie';

const deployedFeatures = ['recount-redesign'];

const useFeature = () => {
  const router = useRouter();
  const [getCookie] = useCookies();

  const isOn = (feature: string) => {
    return (
      deployedFeatures.includes(feature) ||
      (router.query[`f-${feature}`] || getCookie(`feature-${feature}`)) === 'true'
    );
  };
  return {
    isOn,
  };
};

export default useFeature;
